const getDollarsFromCents = (value) => (value || value === 0 ? String(value / 100) : '');

export default getDollarsFromCents;
